module.exports = __webpack_public_path__ + "6b383933195d0bba8ef89f7809657147.svg";